import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, useParams, useNavigate, useLocation } from 'react-router-dom';
import './index.css';
import Landing from './components/Portal/Landing';
import FrontPage from './components/Front';
import Android from './components/Android/Android';
import Legal from './components/Terms/Legal';
import About from "./components/Company/About";
import Rulebook from './components/Rulebook/Rulebook';
import Salesheet from './components/Salesheet/Salesheet';
import Search from './components/Search/Search';
import Results from './components/Search/Results/Results';
import Card from "./components/Card/Card";
import Pack from "./components/Packs/Pack";
// Artists section removed
import SignUp from './components/SignUp/SignUp';
import Events from './components/Events/Events';
import TPSurvey from './components/Events/TPSurvey';
import Preorder from './components/Preorder/Preorder';
import WardenPreorder from './components/Preorder/WardenPreorder';
import NewGenesisPreorder from './components/Preorder/NewGenesisPreorder';
import IndividualPreorder from './components/Preorder/IndividualPreorder';
import BusinessPreorder from './components/Preorder/BusinessPreorder';
import Confirmation from './components/Preorder/Confirmation';
import OrderConfirmation from './components/Preorder/OrderConfirmation';
import OPTour from "./components/Updates/OPTour";
import Ambassador from "./components/Updates/Ambassador";
import Prerelease from "./components/Updates/Prerelease";
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import Decks from './components/Decks/Decks';
import DeckViewer from './components/Decks/DeckViewer';
import DeckBuilder from './components/DeckBuilder/DeckBuilder';

// const pdfjsDistPath = path.dirname(require.resolve('pdfjs-dist/package.json'));
// const pdfWorkerPath = path.join(pdfjsDistPath, 'legacy', 'build', 'pdf.worker.js');

// fs.copyFileSync(pdfWorkerPath, './dist/pdf.worker.js');

unregister();

// HOC to provide navigate, params, and location to class components
const withRouter = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    
    return (
      <Component
        {...props}
        navigate={navigate}
        params={params}
        location={location}
        history={{ push: (path) => navigate(path) }}
      />
    );
  };
};

// Apply HOC to all components
const WrappedSignUp = withRouter(SignUp);
// Artists wrappers removed
const WrappedCard = withRouter(Card);
const WrappedPack = withRouter(Pack);
const WrappedResults = withRouter(Results);
const WrappedSearch = withRouter(Search);
const WrappedSalesheet = withRouter(Salesheet);
const WrappedConfirmation = withRouter(Confirmation);
const WrappedRulebook = withRouter(Rulebook);
const WrappedAbout = withRouter(About);
const WrappedLanding = withRouter(Landing);
const WrappedPreorder = withRouter(Preorder);
const WrappedTPSurvey = withRouter(TPSurvey);
const WrappedOPTour = withRouter(OPTour);
const WrappedAmbassador = withRouter(Ambassador);
const WrappedPrerelease = withRouter(Prerelease);
const WrappedIndividualPreorder = withRouter(IndividualPreorder);
const WrappedBusinessPreorder = withRouter(BusinessPreorder);
const WrappedWardenPreorder = withRouter(WardenPreorder);
const WrappedNewGenesisPreorder = withRouter(NewGenesisPreorder);
const WrappedEvents = withRouter(Events);
const WrappedLegal = withRouter(Legal);
const WrappedDecks = withRouter(Decks);
const WrappedDeckViewer = withRouter(DeckViewer);
const WrappedDeckBuilder = withRouter(DeckBuilder);
const WrappedAndroid = withRouter(Android);
const WrappedFrontPage = withRouter(FrontPage);
const WrappedOrderConfirmation = withRouter(OrderConfirmation);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path='/create-account' element={<WrappedSignUp />} />
        {/* Artists routes removed */}
        <Route path='/card/:id' element={<WrappedCard />} />
        <Route path='/pack/:id' element={<WrappedPack />} />
        <Route path='/search/results/:query' element={<WrappedResults />} />
        <Route path='/search' element={<WrappedSearch />} />
        <Route path='/salesheet' element={<WrappedSalesheet />} />
        <Route path='/order-confirmation' element={<WrappedOrderConfirmation />} />
        <Route path='/rulebook' element={<WrappedRulebook />} />
        <Route path='/dattebayo' element={<WrappedAbout />} />
        <Route path='/portal' element={<WrappedLanding />} />
        <Route path='/preorder' element={<WrappedPreorder />} />
        <Route path='/tpsurvey' element={<WrappedTPSurvey />} />
        <Route path='/optour' element={<WrappedOPTour />} />
        <Route path='/ambassador' element={<WrappedAmbassador />} />
        <Route path='/prerelease' element={<WrappedPrerelease />} />
        <Route path='/preorder-confirmation' element={<WrappedConfirmation />} />
        <Route path='/bethesda' element={<WrappedIndividualPreorder />} />
        <Route path='/preorder-b2b' element={<WrappedBusinessPreorder />} />
        <Route path='/warden' element={<WrappedWardenPreorder />} />
        <Route path='/new-genesis' element={<WrappedNewGenesisPreorder />} />
        <Route path='/events' element={<WrappedEvents />} />
        <Route path='/terms' element={<WrappedLegal />} />
        <Route path='/build' element={<WrappedDeckBuilder />} />
        <Route path='/decks' element={<WrappedDecks />} />
        <Route path='/deck/:id' element={<WrappedDeckViewer />} />
        <Route path='/android' element={<WrappedAndroid />} />
        <Route path='/' element={<WrappedFrontPage />} />
      </Routes>
    </Router>
  </React.StrictMode>
);